import React from 'react';
import classNames from 'classnames';
import './spinner.scss';

const Spinner = ({ styleModifier = '' }) => (
  <div>
    <svg className={classNames('spinner', styleModifier)} viewBox="22 22 44 44">
      <circle
        className="spinner__circle spinner__circle--bg"
        cx="44"
        cy="44"
        r="20"
      />
      <circle
        className="spinner__circle spinner__circle--dash"
        cx="44"
        cy="44"
        r="20"
      />
    </svg>
  </div>
);
export default Spinner;
